import { render, staticRenderFns } from "./balanceGlobal.vue?vue&type=template&id=6ce8f984&scoped=true"
import script from "./balanceGlobal.vue?vue&type=script&lang=js"
export * from "./balanceGlobal.vue?vue&type=script&lang=js"
import style0 from "./balanceGlobal.vue?vue&type=style&index=0&id=6ce8f984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8f984",
  null
  
)

export default component.exports